import React from 'react';
import { ResponsiveBar } from '@nivo/bar';
import './scss/export-plotbar.scss';

// BarGraph to be used within page header

// Custom Label Used for Right Axis
const AxisLabel = ({ value = '', points = 0 }) => {
  let pointsLabel = points > 1 ? 'points' : 'point';
  return (
    <React.Fragment>
      <tspan className="font-weight-bold" x="0" dy="-0.5em">
        {value}
      </tspan>
      <tspan x="0" dy="1.2em">
        {points} {pointsLabel}
      </tspan>
    </React.Fragment>
  );
};

const ExportPlotBar = ({
  className = null,
  data = [],
  height = '',
  innerPadding = 0,
  layout = null,
  margin = null,
  width = '',
  ...props
}) => {
  return (
    <div className={`points-allocation-bargraph ${className ? className : ''}`}>
      <div className="points-allocation-bargraph__wrapper" style={{ height, width }}>
        <ResponsiveBar
          animate={true}
          axisRight={{
            format: value => {
              let val = value.charAt(0).toUpperCase() + value.slice(1);
              let points = data.filter( d => {
                return d.id ===  value;
              });
              return <AxisLabel value={val} points={points[0].value} />;
            },
            tickSize: 0,
            tickPadding: 5,
            legend: '',
            legendOffset: 0
          }}
          axisBottom={null}
          axisTop={null}
          axisLeft={null}
          colors={bar => bar.data.color}
          data={data}
          enableGridY={false}
          layout={layout}
          margin={margin}
          label={() => false}
          innerPadding={innerPadding}
          labelTextColor={{ from: 'color', modifiers: [['darker', 1.6]] }}
          motionStiffness={90}
          motionDamping={15}
          padding={0.25}
          {...props}
        />
      </div>
    </div>
  );
};

ExportPlotBar.defaultProps = {
  data: [],
  height: '70px',
  innerPadding: 10,
  layout: 'horizontal',
  margin: { top: 0, right: 100, bottom: 0, left: 0 },
  width: '270px'
};

export default ExportPlotBar;
